"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTimestamp = isTimestamp;
exports.isGeoPoint = isGeoPoint;
function isTimestamp(v) { return !!v && (typeof v == 'object') && !!v.toDate && !!v.toMillis && (typeof v.nanoseconds == 'number') && (typeof v.seconds == 'number'); }
;
function isGeoPoint(v) { return !!v && (typeof v == 'object') && (typeof v.isEqual == 'function') && (typeof v.latitude == 'number') && (typeof v.longitude == 'number'); }
;
//# sourceMappingURL=firestore.js.map